<div class="list-for-loyalty-program-products">
    <div class="inner list-for-loyalty-program-products__inner row">

        <ng-container *ngIf="loading === true">
            <div class="item list-for-loyalty-program-products__item col"
                *ngFor="let item of emptyPlaceholders; trackBy: trackBy">
                <shared-tile-for-loyalty-program-product [loading]="true"
                                                         class="list-for-loyalty-program-products__tile">
                </shared-tile-for-loyalty-program-product>
            </div>
        </ng-container>

        <ng-container *ngIf="loading === false">
            <div *ngIf="!!loyaltyPoints" class="item list-for-rewards__item col">
                <shared-tile-for-loyalty-points [loyaltyPoints]="loyaltyPoints"></shared-tile-for-loyalty-points>
            </div>

            <ng-container *ngIf="!isEmpty">
                <ng-container *ngFor="let programItem of programProducts | limit:limit; trackBy: trackBy">
                    <div class="item list-for-loyalty-program-products__item col">
                        <shared-tile-for-loyalty-program-product [programItem]="programItem"
                                                                 class="list-for-loyalty-program-products__tile">
                        </shared-tile-for-loyalty-program-product>
                    </div>
                </ng-container>
            </ng-container>

        </ng-container>

    </div>
</div>
